module.exports = __webpack_public_path__ + "img/team-link.5a3f4ec4.gif";